import { render, staticRenderFns } from "./maximalize-outlined.vue?vue&type=template&id=fa6d027e&scoped=true&"
var script = {}
import style0 from "./maximalize-outlined.vue?vue&type=style&index=0&id=fa6d027e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6d027e",
  null
  
)

export default component.exports